<template>
  <div class="ff-loading" :class="{'is-full': full}">
    <svg :class="{'is-active': active}" class="svg is-loading" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="svg-path" d="M13 8C13 9.10287 12.6429 10.1223 12.0381 10.9491C11.8735 11.1741 11.8906 11.4926 12.1006 11.6758C12.3066 11.8555 12.6206 11.8374 12.7857 11.6195C13.5478 10.6134 14 9.35952 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 9.31646 2.42397 10.5339 3.14282 11.5232C3.30777 11.7502 3.6317 11.7692 3.84022 11.5815C4.04239 11.3994 4.06 11.0907 3.90378 10.868C3.33426 10.0561 3 9.06706 3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8Z"/>
    </svg>
    <svg :class="{'is-active': saved}" class="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="svg-path" d="M6.82843 11.364L12.1317 6.06066C12.327 5.8654 12.327 5.54882 12.1317 5.35355V5.35355C11.9365 5.15829 11.6199 5.15829 11.4246 5.35355L6.82843 9.94975L5.06066 8.18198C4.8654 7.98672 4.54882 7.98672 4.35355 8.18198V8.18198C4.15829 8.37724 4.15829 8.69382 4.35355 8.88909L6.82843 11.364Z"/>
    </svg>
  </div>
</template>

<script>
const SAVED_STALL = 2000
export default {
  name: 'ff-inline-loading',
  props: [
    'saving',
    'full'
  ],
  data () {
    return {
      saved: false
    }
  },
  computed: {
    active () {
      if (this.saving) return true
      this.activate()
      return false
    }
  },
  methods: {
    activate () {
      this.saved = true
      setTimeout(()=>{
        this.saved = false
      }, SAVED_STALL)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-loading {
    font-size: $fontSize-normal;
    margin-bottom: $unit-1;

    &.is-full {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes activate {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    10% {
      transform: scale(1.25);
    }
    20% {
      transform: scale(1);
    }
    90% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }

  .svg {
    opacity: 0;
    position: absolute;
    left: -32px;
    top: calc(50% + 5px);
  }

  .svg.is-loading {
    animation: rotate .7s cubic-bezier(.33,.35,.78,.94) infinite;
  }

  .svg-path {
    fill: $color-dark;
  }

  .is-active {
    opacity: 1;
    animation: activate 2s cubic-bezier(.33,.35,.78,.94) infinite;
  }

  .is-full {
    .svg {
      position: static;
    }
  }

</style>
